import React, {useState} from "react";
import {FormControl} from "@mui/material";

export const RangeColumnFilter = ({colDef, onChange}) => {

    const [filterState, setFilterState] = useState({
        columnDef: colDef,
        operator: null,
        operand: null,
        between: {
            start: null,
            end: null
        }
    });

    return <div className={"canold-table-column-range-filter-container"}>
        <p className={"canold-table-filter-label"}>or fall between</p>
        <FormControl>
            <input
                type={"text"}
                onKeyUp={(evt) => {
                    evt.stopPropagation();
                    const newFilterState = {
                        ...filterState,
                        between: {
                            ...filterState.between,
                            start: evt.target.value,
                        }
                    };
                    setFilterState(newFilterState);
                    onChange(colDef, newFilterState, evt);
                }}
                placeholder={"Starting Value"}
                className={"canold-table-range-column-filter-input-start"}
            />
            <p>and</p>
            <input
                type={"text"}
                onKeyUp={(evt) => {
                    evt.stopPropagation();
                    const newFilterState = {
                        ...filterState,
                        between: {
                            ...filterState.between,
                            end: evt.target.value,
                        }
                    };
                    setFilterState(newFilterState);
                    onChange(colDef, newFilterState, evt);
                }}
                placeholder={"Ending Value"}
                className={"canold-table-range-column-filter-input-end"}
            />
        </FormControl>
    </div>;

};

export default RangeColumnFilter;